<template>
  <div class="list-box" style="position: relative">
    <div style="display: flex; align-items: center; margin-bottom: 10px">
      <div style="display: flex; align-items: center; flex: 1">
        <text style="color: #a2a2a2">月份：</text>
        <el-date-picker
          v-model="state.skssq"
          type="month"
          placeholder="税款所属月份"
          value-format="YYYYMM"
          format="YYYY年M月"
          style="width: 160px; margin-right: 10px"
          :clearable="false"
        />
        <li style="color: #ffa500; font-size: 12px">
          由于数据量较大，列表默认不加载数据，请先选择扣缴义务人后，再点击查询检索相关数据
        </li>
      </div>
      <li
        v-if="state.selectIds?.filter((w) => w != -1)?.length > 0"
        style="display: flex; align-items: flex-end"
      >
        已选择<strong style="color: #1e90ff; margin: 0 5px">{{
          state.selectIds?.filter((w) => w != -1)?.length
        }}</strong
        >条数据
        <el-button
          type="danger"
          :icon="Delete"
          link
          @click="state.selectIds = []"
          style="margin-right: 20px"
        >
          清空已选
        </el-button>
      </li>
      <el-button type="primary" @click="onSubmit">提交更新申请</el-button>
      <el-button type="info" @click="onClose">取消</el-button>
    </div>
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <div>
          <li class="group-title" icon="*">扣缴义务人</li>
          <div style="display: flex; align-items: center; width: 300px">
            <el-input
              v-model="state.withholding_agent_name"
              class="withholding_agent_single"
              placeholder="点击选择扣缴义务人"
              input-style="padding-right: 25px;cursor: pointer;"
              clearable
              readonly
              @clear="
                delete state.params.keywords;
                onLoad();
              "
              @click="state.showWithholdingAgent = true"
            ></el-input>
            <el-icon
              v-if="state.withholding_agent_name"
              style="margin-left: -25px; cursor: pointer"
              color="#a2a2a2"
              @click.stop="
                delete state.withholding_agent;
                delete state.withholding_agent_name;
                delete state.params.withholding_agent_id;
              "
            >
              <CircleClose />
            </el-icon>
          </div>
        </div>
        <el-input
          v-model="state.params.keywords"
          style="width: 300px"
          placeholder="姓名、电话、身份证号、银行卡号"
          clearable
          @clear="
            delete state.params.keywords;
            onLoad();
          "
          @paste.enter="$onKeywordsPaste($event, state.params)"
        ></el-input>
        <el-select
          v-model="state.params.customer_id"
          placeholder="所属客户"
          style="width: 300px"
        >
          <el-option
            v-for="item in state.customerData"
            :key="item.id"
            :label="item.alias + '(' + item.name + ')'"
            :value="item.id"
          />
          <template #footer>
            <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
          </template>
        </el-select>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
    </ul>
    <ul class="list-table">
      <el-checkbox-group
        v-model="state.selectIds"
        style="flex: 1; display: flex; flex-direction: column; overflow: hidden"
      >
        <el-table
          ref="tableDom"
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :default-sort="{
            prop: state.params.sort_field,
            order:
              state.params.sort_value == 'desc' ? 'descending' : 'ascending',
          }"
          @sort-change="onSortChange"
          @row-click="onRowClick"
        >
          <el-table-column width="55" fixed @click.stop="">
            <template #header>
              <el-checkbox :value="-1" @change="onSelect($event, -1)" />
            </template>
            <template #default="{ row }">
              <el-checkbox
                :value="row.id"
                @change="onRowClick(row)"
                :disabled="row.collected_status == 2"
              />
            </template>
          </el-table-column>
          <el-table-column
            fixed
            label="序号"
            width="70"
            type="index"
            :index="
              (index) =>
                (state.params.page - 1) * state.params.limit + index + 1
            "
            align="center"
          />
          <el-table-column
            prop="name"
            label="姓名"
            :formatter="
              (row, column, cellValue) =>
                $tab_Highlinght(cellValue, state.params.keywords)
            "
            width="100"
            fixed
          />
          <el-table-column
            prop="phone"
            label="手机号"
            :formatter="
              (row, column, cellValue) =>
                $tab_Highlinght(cellValue, state.params.keywords)
            "
            width="120"
          >
            <template #default="{ row }">
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                title="手机号"
                @click="$onCopy(row.phone)"
              >
                {{ row.phone }}
              </text>
            </template>
          </el-table-column>
          <el-table-column
            prop="idcard"
            label="证件号"
            :formatter="
              (row, column, cellValue) =>
                $tab_Highlinght(cellValue, state.params.keywords)
            "
            width="180"
          >
            <template #default="{ row }">
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                title="证件号"
                @click="$onCopy(row.idcard)"
              >
                {{ row.idcard }}
              </text>
            </template>
          </el-table-column>
          <el-table-column
            label="报送状态"
            prop="declare_status"
            sortable="declare_status"
            width="140"
            align="center"
          >
            <template #default="{ row }">
              <el-tooltip
                effect="dark"
                content="员工信息变更，可重新报送！"
                v-if="row.declare_status == 1 && row.is_need_declare == 1"
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    line-height: 14px;
                  "
                >
                  <div
                    style="
                      width: fit-content;
                      color: #ffa500;
                      font-size: 14px;
                      margin-right: 3px;
                    "
                  >
                    已报送
                  </div>
                  <el-icon><QuestionFilled /></el-icon>
                </div>
              </el-tooltip>
              <template v-else>
                <el-tooltip
                  effect="dark"
                  :content="row.declare_msg"
                  v-if="row.declare_msg"
                >
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      cursor: pointer;
                    "
                  >
                    <c_status
                      arrName="employeedeclare_declare_status"
                      :value="row.declare_status"
                    />
                    <el-icon><QuestionFilled /></el-icon>
                  </div>
                </el-tooltip>
                <c_status
                  arrName="employeedeclare_declare_status"
                  :value="row.declare_status"
                  style="margin: 0 auto"
                  v-else
                ></c_status>
              </template>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="人员状态"
            :formatter="$tab_TextFormat"
            align="center"
            width="100"
          >
            <template #default="{ row }">
              <ul :style="{ color: row.status == 0 ? '#f00' : '#1e90ff' }">
                {{
                  row.status == 0 ? "离职" : "在职"
                }}
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="sex" label="性别" align="center" width="80">
            <template #default="{ row }">
              <text v-if="row.sex == '男'" style="color: #1e90ff">男</text>
              <text v-else-if="row.sex == '女'" style="color: #f00">女</text>
              <text v-else>-</text>
            </template>
          </el-table-column>
          <el-table-column
            prop="idtype"
            label="证件类型"
            :formatter="$tab_TextFormat"
            width="120"
          />
          <el-table-column
            prop="withholding_agent_name"
            label="扣缴义务人"
            :formatter="$tab_TextFormat"
            min-width="240"
          >
            <template #default="{ row }">
              <div
                :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
                :style="{
                  '--dynamic-color':
                    row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
                }"
                class="withholding-badge"
              >
                {{ row.withholding_agent_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="统一社会信用代码" width="220">
            <template #default="{ row }">
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                @click.stop="$onCopy(row.unified_social_credit_identifier)"
                v-if="row.unified_social_credit_identifier"
              >
                {{ row.unified_social_credit_identifier }}
              </text>
              <text v-else>-</text>
            </template>
          </el-table-column>
          <el-table-column
            prop="property"
            label="属性"
            :formatter="
              (row) =>
                $statusFormat({
                  Text: row.property == 0 ? '雇员' : '其他',
                  Color: row.property == 0 ? '#1e90ff' : '#ffa500',
                })
            "
            width="80"
          />
          <el-table-column
            prop="skssq"
            label="税款所属期"
            :formatter="$tab_TextFormat"
            width="120"
          />
          <el-table-column
            prop="entry_time"
            label="入职日期"
            :formatter="$tab_TextFormat"
            width="120"
          />
          <el-table-column
            prop="resignation_time"
            label="离职日期"
            :formatter="$tab_TextFormat"
            width="120"
          />
          <el-table-column
            prop="name"
            label="收款信息"
            :formatter="
              (row) =>
                $tab_GroupFormat(row.opening_bank || '-', row.bank_account)
            "
            min-width="200"
          >
            <template #default="{ row }">
              <div style="display: flex; align-items: center; width: 100%">
                <el-tag
                  v-if="row.diff_bank_status != 0"
                  effect="dark"
                  size="small"
                  :type="row.diff_bank_status == 1 ? 'warning' : 'danger'"
                  :title="
                    row.diff_bank_status == 1
                      ? '异卡发放审核中'
                      : '异卡审核已驳回'
                  "
                  style="cursor: pointer; margin-right: 5px"
                >
                  {{ row.diff_bank_status == 1 ? "审" : "驳" }}
                </el-tag>
                <div
                  style="flex: 1; overflow: hidden"
                  v-html="
                    $tab_BuildGroup(row.opening_bank || '-', row.bank_account)
                  "
                ></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="declare_time"
            label="报送时间"
            :formatter="$tab_TextFormat"
            width="180"
          />
          <el-table-column
            prop="verify_status_name"
            label="身份验证状态"
            :formatter="$tab_TextFormat"
            width="140"
          />
          <el-table-column
            prop="verify_msg"
            label="原因"
            :formatter="$tab_ShowToolTip"
            min-width="220"
          />
        </el-table>
      </el-checkbox-group>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showWithholdingAgent"
        title="选择扣缴义务人"
        @close="state.showWithholdingAgent = false"
      >
        <c_WithholdingAgentSelectSingle
          @close="
            (item) => {
              state.withholding_agent_name = item.name;
              state.withholding_agent = item;
              state.params.withholding_agent_id = item.id;
              state.showWithholdingAgent = false;
            }
          "
          :selectItem="state.withholding_agent"
        ></c_WithholdingAgentSelectSingle>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  data_customer_select,
  data_withholdingagent_employee_page,
} from "@/http/data";
import { essential_pull } from "@/http/essential";
import { ElMessage, ElMessageBox, dayjs } from "element-plus";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  props: {
    skssq: String,
  },
  setup(props, { emit }) {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
      tableData: [],
      selectIds: [],
    });
    onMounted(() => {
      state.skssq = props.skssq;

      onLoadCustomer();
    });

    const onLoad = () => {
      if (!state.params.withholding_agent_id) {
        ElMessage.warning("请先选择扣缴义务人！");
        return false;
      }

      delete state.tableData;
      data_withholdingagent_employee_page(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    const onClose = () => {
      emit("Close");
    };

    const onSelect = (checked, item) => {
      if (item == -1) {
        if (checked) {
          state.selectIds = [
            ...state.selectIds,
            ...state.tableData
              .filter(
                (w) =>
                  w.collected_status != 2 && !state.selectIds.includes(w.id),
              )
              .map((m) => m.id),
          ];
        } else {
          state.selectIds = state.selectIds.filter(
            (w) => !state.tableData.map((m) => m.id).includes(w),
          );
        }
      }
    };

    const onRowClick = (item) => {
      console.log(item);

      if (state.selectIds?.includes(item.id)) {
        state.selectIds = state.selectIds.filter((w) => w != item.id);
      } else state.selectIds.push(item.id);
    };

    const onSubmit = () => {
      if (state.selectIds?.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要更新的员工",
          grouping: true,
        });
        return false;
      }

      if (!state.skssq) {
        ElMessage({
          type: "warning",
          message: "请选择要更新的月份",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您确定更新已选<strong style='color:#1e90ff'>${
          state.selectIds.filter((w) => w != -1)?.length
        }条</strong>员工<strong style='color:#ffa500'>${dayjs(
          state.skssq,
        ).format("YYYY年M月")}</strong>的专项附件扣除数据吗？`,
        "更新确认",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定更新",
          cancelButtonText: "取消",
          type: "warning",
        },
      ).then(() => {
        const data = {
          withholding_agent_id: state.params.withholding_agent_id,
          id: state.selectIds.join(","),
          skssq: state.skssq,
        };
        essential_pull(data).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            emit("Comfirm");
          }
        });
      });
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onLoadCustomer,
      onRowClick,
      props,
      tableDom,
      onClose,
      onSubmit,
      onSelect,
    };
  },
};
</script>
<style scoped></style>
